import { fork } from 'redux-saga/effects';

import { RootSagaReturnType } from '~types/saga';
import watchGetCustomerTransferListing from './getCustomerTransferListing';
import CustomerTransferGateway from '~apis/customerTransfer';
import watchGetExportCustomerTransferListing from './getExportCustomerTransferListing';
import watchGetCustomerTransferDetails from './getCustomerTransferDetails';
import watchCreateCustomerTransferDrafts from './createCustomerTransferDrafts';
import watchCreateCustomerTransferFinalDrafts from './createCustomerTransferFinalDrafts';
import watchGetCustomerTransferSummary from './getCustomerTransferSummary';
import watchCreateCustomerTransfer from './createCustomerTransfer';

export default (api: CustomerTransferGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetCustomerTransferListing, api);
        yield fork(watchGetExportCustomerTransferListing, api);
        yield fork(watchGetCustomerTransferDetails, api);
        yield fork(watchCreateCustomerTransferDrafts, api);
        yield fork(watchCreateCustomerTransferFinalDrafts, api);
        yield fork(watchGetCustomerTransferSummary, api);
        yield fork(watchCreateCustomerTransfer, api);
    }

    return {
        rootSaga,
    };
};
